import { createSvgIcon } from "@mui/material";

const DeleteDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.3333C0 9.55126 9.55126 0 21.3333 0H58.6667C70.4487 0 80 9.55126 80 21.3333V58.6667C80 70.4487 70.4487 80 58.6667 80H21.3333C9.55126 80 0 70.4487 0 58.6667V21.3333Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M57.3713 60.3166L62.2339 30.7684C62.4566 29.4152 61.4125 28.1853 60.0412 28.1853H28.6493C27.278 28.1853 26.2339 29.4151 26.4565 30.7683L28.6938 44.3682L29.9326 51.8902L31.0831 58.8814L31.3193 60.3166C31.7433 62.8932 33.9706 64.7839 36.5819 64.7839H52.1087C54.72 64.7839 56.9473 62.8932 57.3713 60.3166Z"
      fill="#F3D0D1"
    />
    <path
      d="M62.3949 22.2747L62.4747 22.2769C63.2966 22.3186 63.9504 22.998 63.9504 23.8303C63.9504 24.6626 63.2966 25.342 62.4747 25.3837L62.3949 25.3859H18.078C17.2189 25.3859 16.5225 24.6894 16.5225 23.8303C16.5225 22.9712 17.2189 22.2747 18.078 22.2747H62.3949Z"
      fill="#F44336"
    />
    <path
      d="M45.1441 22.5642C45.1441 19.8781 43.055 17.7887 40.3689 17.7886C37.6827 17.7886 35.5933 19.878 35.5933 22.5642C35.5932 23.4233 34.8968 24.1198 34.0377 24.1198C33.1787 24.1198 32.4823 23.4233 32.4822 22.5642C32.4822 18.1598 35.9645 14.6775 40.3689 14.6775C44.7732 14.6776 48.2552 18.1599 48.2552 22.5642C48.2551 23.4233 47.5587 24.1198 46.6996 24.1198C45.8406 24.1198 45.1442 23.4232 45.1441 22.5642Z"
      fill="#F44336"
    />
    <path
      d="M44.2004 36.0528C44.8079 35.4454 45.793 35.4454 46.4005 36.0528C47.0078 36.6603 47.0078 37.645 46.4005 38.2525L36.2707 48.3823C35.6633 48.9896 34.6785 48.9896 34.0711 48.3823C33.4636 47.7748 33.4636 46.7897 34.0711 46.1822L44.2004 36.0528Z"
      fill="#F44336"
    />
    <path
      d="M46.4005 46.1822C47.008 46.7897 47.008 47.7748 46.4005 48.3823C45.793 48.9897 44.8079 48.9897 44.2004 48.3823L46.4005 46.1822ZM34.0711 36.0528C34.6786 35.4454 35.6633 35.4454 36.2707 36.0528L46.4005 46.1822L44.2004 48.3823L34.0711 38.2525C33.4636 37.645 33.4636 36.6603 34.0711 36.0528Z"
      fill="#F44336"
    />
    <path
      d="M57.03 24.4243C57.2045 23.6201 57.9809 23.0857 58.8021 23.2208C59.6498 23.3603 60.2242 24.1604 60.0847 25.0081L54.7969 57.1392C54.2492 60.4673 51.3724 62.9095 47.9996 62.9096H32.4727C29.0998 62.9096 26.2226 60.4673 25.6749 57.1392L25.4388 55.7043L28.5087 55.1991L28.7448 56.634C29.0452 58.4591 30.623 59.7985 32.4727 59.7985H47.9996C49.8492 59.7984 51.4267 58.459 51.727 56.634L57.0148 24.5029L57.03 24.4243ZM26.7214 53.9165C27.569 53.7771 28.3692 54.3514 28.5087 55.1991L25.4388 55.7043C25.2993 54.8566 25.8737 54.056 26.7214 53.9165ZM21.6697 23.2208C22.491 23.0857 23.2678 23.6201 23.4423 24.4243L23.4571 24.5029L26.1194 40.686C26.2587 41.5336 25.6848 42.3338 24.8373 42.4734C23.9895 42.6128 23.189 42.0385 23.0495 41.1908L20.3876 25.0081L20.3763 24.9287C20.284 24.1109 20.8486 23.3559 21.6697 23.2208Z"
      fill="#F44336"
    />
  </svg>,
  "DeleteDialogIcon"
);

export default DeleteDialogIcon;
